import React, { Fragment, useEffect, useState } from "react";
import { Card, Form, Row, Col } from "react-bootstrap";
import { formato_monto } from '../../common/Formatos.js'
import { serviceGetDocumento } from '../../api/api-visar-rendicion-recupero.js';
import { descargarArchivo } from '../../common/descargarArchivo';
import { LoadingComponent } from 'recupero-comunes';
import { useSelector } from 'react-redux'

const VisarRendicionTotal = ({cfg_form, declaracionPago}) => {
    
    const [loading, setLoading] = useState(false);

    const data_visar = useSelector((state) => state.visarRendicionRecuperoReducer)
    const {llaves} = data_visar

    const [idFolioCargaReciboPago, setFolioCargaReciboPago] = useState(null);
    
    useEffect(() => {
        if (declaracionPago && declaracionPago['cuotas']) {            
            setFolioCargaReciboPago(declaracionPago?.rendicion?.idFolioCargaReciboPago);
        }
    }, [declaracionPago]);
    
    const verDocumento = async (folioDocumento) => {
    
        try {        
            if (folioDocumento) {
                setLoading(true); 
                let parametros = JSON.stringify({
                    idCaso: llaves && llaves['idCaso'],
                    idImplicadoCaso: llaves && llaves['idImplicado'],
                    idCompania: llaves && llaves['idOrgCaso'],
                    idfolioCarga: folioDocumento
                });
                console.log("en handleDocumento...", parametros);
                let query = Buffer.from(parametros).toString('base64')

                const response = await serviceGetDocumento(query);
                setLoading(false);

                descargarArchivo(response);
            }
        } catch (error) {
            console.log("error:", error);
            setLoading(false);
        }
    }
  return (
    <>
    <style type='text/css'>
        {`
        .btn-carpeta {
            background-color: #F0AD3E;
            color: #FFFFFF;
            width: 140px;
        }
        .btn-carpeta:hover{
            background-color:#e1b97f;
            color: #FFFFFF;
        }
        .btn-actualizar {
            background-color: #C14B49;
            color: #FFFFFF;
            width: 140px;
            padding:6px 0px 6px 0px;
        }
        .btn-actualizar:hover{
            background-color:  #F6897E;
            color: #FFFFFF;
        }
        .btn-volver {
            color: #66CCCC;
            border: 1px solid #C00
            width: 140px;
        }
    `}
      </style>
    <LoadingComponent show={loading} />
        <Card className="mb-3 p-3">
            <Card.Header className='mt-0 mb-0' as='h6' style={{ backgroundColor: '#4F517A', color: 'white' }}>
                {(cfg_form && cfg_form["rinde-cuotas-ingrend-subtitle"]) ? cfg_form["rinde-cuotas-ingrend-subtitle"] : 'Rendición Pago Total'} - N° {declaracionPago?.rendicion?.idRendicionPago}
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col>
                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {(cfg_form && cfg_form["visar-rendicion-recupero-lbl-montorendido"]) ? cfg_form["visar-rendicion-recupero-lbl-montorendido"] : 'Monto Rendido'}
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3'>
                            {declaracionPago && declaracionPago?.rendicion ? formato_monto(parseFloat(declaracionPago?.rendicion?.montoRendido)) : 0}
                        </Form.Text>
                    </Col>
                    <Col>
                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {(cfg_form && cfg_form["visar-rendicion-recupero-lbl-mediopago"]) ? cfg_form["visar-rendicion-recupero-lbl-mediopago"] : 'Medio de Pago'}
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3'>
                            {declaracionPago && declaracionPago?.rendicion ? declaracionPago?.medioPago : ""}
                        </Form.Text>
                    </Col>
                    <Col>
                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {(cfg_form && cfg_form["visar-rendicion-recupero-lbl-banco"]) ? cfg_form["visar-rendicion-recupero-lbl-banco"] : 'Banco/Institución'}
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3'>
                            {declaracionPago && declaracionPago?.rendicion ? declaracionPago?.rendicion?.banco : ""}
                        </Form.Text>
                    </Col>
                    <Col>
                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {(cfg_form && cfg_form["visar-rendicion-recupero-lbl-nrocheque"]) ? cfg_form["visar-rendicion-recupero-lbl-nrocheque"] : 'Nro.Cheque/Transacción'}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3'>
                            {declaracionPago && declaracionPago?.rendicion ? declaracionPago?.rendicion?.nroChequeTrans : ""}
                        </Form.Text>
                    </Col>
                    <Col>
                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {(cfg_form && cfg_form["visar-rendicion-recupero-lbl-fechatrx"]) ? cfg_form["visar-rendicion-recupero-lbl-fechatrx"] : 'Fecha Transacción'}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3'>
                            {declaracionPago && declaracionPago?.rendicion ? declaracionPago?.rendicion?.fechaTransaccionFormat : ""}
                        </Form.Text>
                    </Col>
                    <Col>
                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {(cfg_form && cfg_form["visar-rendicion-recupero-lbl-fecharend"]) ? cfg_form["visar-rendicion-recupero-lbl-fecharend"] : 'Fecha Rendición'}  
                        </Form.Label>
                        <br />
                        <Form.Text className='mb-3'>
                            {declaracionPago && declaracionPago?.rendicion ? declaracionPago?.rendicion?.fechaRendicionFormat : ""}
                        </Form.Text>
                    </Col>
                    <Col>
                        <Form.Label className='mb-0' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                            {(cfg_form && cfg_form["visar-rendicion-recupero-lbl-comprobante"]) ? cfg_form["visar-rendicion-recupero-lbl-comprobante"] : 'Comprobante'}  
                        </Form.Label>
                        <br />
                        <a 
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                if (!idFolioCargaReciboPago) {                                
                                    return;
                                }
                                verDocumento(idFolioCargaReciboPago); 
                            }}  
                            style={{ display: 'flex', alignItems: 'center', marginTop: '10px', 
                                color: !idFolioCargaReciboPago ? 'gray' : 'red',
                                pointerEvents: !idFolioCargaReciboPago ? 'none' : 'auto',
                                opacity: !idFolioCargaReciboPago ? 0.5 : 1
                            }}
                            >
                            {/* SVG como ícono */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-file-earmark-pdf" viewBox="0 0 20 20">
                                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"/>
                                <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z"/>
                            </svg>
                        </a>
                    </Col>
                </Row>                
                <br/>
            </Card.Body>
        </Card>
    </>
  );
};
export default VisarRendicionTotal;